const animationProfessorCongratulations = '/animations/professor_congratulations/animation.json';
const animationProfessorIdle = '/animations/professor_idle/animation.json';
const animationProfessorMove = '/animations/professor_move/animation.json';
const animationProfessorSleep = '/animations/professor_sleep/animation.json';
const animationProfessorTalk = '/animations/professor_talk/animation.json';
const animationProfessorWait = '/animations/professor_wait/animation.json';

export default {
  PROFESSOR_CONGRATULATIONS: [
    {
      data: animationProfessorCongratulations,
      audio: null,
    },
  ],
  PROFESSOR_IDLE: [
    {
      data: animationProfessorIdle,
      audio: null,
    },
  ],
  PROFESSOR_MOVE: [
    {
      data: animationProfessorMove,
      audio: null,
    },
  ],
  PROFESSOR_SLEEP: [
    {
      data: animationProfessorSleep,
      audio: null,
    },
  ],
  PROFESSOR_TALK: [
    {
      data: animationProfessorTalk,
      audio: null,
    },
  ],
  PROFESSOR_WAIT: [
    {
      data: animationProfessorWait,
      audio: null,
    },
  ],
};
